export type EventEmitter<EventName extends string = string, Payload = any> = {
  on: (event: EventName, handler: (payload: Payload) => void) => void
  off: (event: EventName, handler: (payload: Payload) => void) => void
  emit: (event: EventName, payload: Payload) => void
}

export function createEventEmitter<
  EventName extends string = string,
  Payload = any
>(): EventEmitter<EventName, Payload> {
  const listeners: Record<
    EventName,
    Set<(payload: Payload) => void>
  > = {} as any

  return {
    on(event, handler) {
      ;(listeners[event] ||= new Set()).add(handler)
    },
    off(event, handler) {
      listeners[event]?.delete(handler)
    },
    emit(event, payload) {
      // Copy handlers to array to avoid mutation during iteration
      const handlers = listeners[event] ? Array.from(listeners[event]) : []
      handlers.forEach((fn) => fn(payload))
    },
  }
}
